export default __webpack_public_path__ + "1c1c2d246a5d8b85e22db7b2f5050388.svg";